import { PropertiesByCategory } from '../Interface/Response/ProductProperty/List/PropertiesByCategory';
import { FilterService } from './FilterService';

export const getFilteredProperties = (
    propertiesByCategories: PropertiesByCategory[],
    keyword: string
): PropertiesByCategory[] => {
    const filterService = new FilterService();

    return propertiesByCategories.map(
        propertiesByCategory => ({
            name: propertiesByCategory.name,
            properties: filterService.filter(propertiesByCategory.properties, keyword)
        })
    ).filter(propertiesByCategory => propertiesByCategory.properties.length > 0);
}
